module.exports = __webpack_public_path__ + "img/core-3.9760e396.png";